import { CLEAR_FILTER_SELECTED_PIDS } from "../../../enums/Employees/employees.types";

export const clearFilterSelectedPidsAction = () => {
    return {
        type: CLEAR_FILTER_SELECTED_PIDS,
    };
};